import {EnsAlertNotification} from "../../../store/features/ens/types";

export const ENS_NOTIFICATION_POLL_INTERVAL_MS = 15_000;
export const ENS_NOTIFICATION_PAGE_LIMIT = 20;

export const getEnsNotificationCursorKey = (tenant: string, userId: string): string =>
    `ens.notificationCursor.v1:${tenant}:${userId}`;

export const parseEnsNotificationCursor = (value: string | null): number | null => {
    if (value == null || !/^\d+$/.test(value)) return null;
    const cursor = Number(value);
    return Number.isSafeInteger(cursor) ? cursor : null;
};

export const readEnsNotificationCursor = (key: string): number | null => {
    try {
        return parseEnsNotificationCursor(sessionStorage.getItem(key));
    } catch {
        return null;
    }
};

export const writeEnsNotificationCursor = (key: string, cursor: number): void => {
    try {
        sessionStorage.setItem(key, String(cursor));
    } catch {
        // Polling can continue with the in-memory cursor when storage is unavailable.
    }
};

export const getEnsNotificationRetryDelay = (failureCount: number): number => {
    if (failureCount <= 1) return 15_000;
    if (failureCount === 2) return 30_000;
    return 60_000;
};

export const takeUnseenEnsNotifications = (
    notifications: readonly EnsAlertNotification[],
    seenNotificationIds: Set<number>,
): EnsAlertNotification[] =>
    [...notifications]
        .sort((left, right) => left.notificationId - right.notificationId)
        .filter((notification) => {
            if (seenNotificationIds.has(notification.notificationId)) return false;
            seenNotificationIds.add(notification.notificationId);
            return true;
        });
